<div class="flex-container">
  <app-strategy-topics *ngIf="tabSelected === 1"></app-strategy-topics>
  <app-strategy-investment *ngIf="tabSelected === 2"></app-strategy-investment>
  <app-strategy-ch-risk *ngIf="tabSelected === 3"></app-strategy-ch-risk>
  <app-strategy-personalise *ngIf="tabSelected === 4"></app-strategy-personalise>
  <app-strategy-portfolio *ngIf="tabSelected === 5" [step]="step"></app-strategy-portfolio>
</div>
